﻿$.fn.dxCtrlTextEmail = function custom_dxCtrlTextEmail(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrltextemail dx-ctrl");
        this.createInstance(new cdxCtrlTextEmail(this, option));
    }
    return this;
}

window.cdxCtrlTextEmail = function (container, option) {
    var Me = this;
    if (typeof option.value == 'undefined' || option.value == null) option.value = "";
    if (typeof option.mode == 'undefined') option.mode = "email";

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            switch (name) {
                case "value": return currentValue; break;
                default: return dx.option(name);
            }
        }
        else {
            switch (name) {
                case "value": currentValue = value;
                default: dx.option(name, value);
            }
        }
    }

    var dx = null;
    var currentValue = null;
    var $DivErreur = null;
    this.hasErreur = false
    function mConstruit() {
        container.empty();
        option.mode = "text";
        if (typeof option.obligatoire != 'undefined' && option.obligatoire) container.addClass("saisie_obligatoire")
        currentValue = option.value;
        option.inputAttr = { autocomplete: 'test-autocomplete' }
        var oncontentready = option.onContentReady
        option.onContentReady = function (e) {
            //focus suivant sur enter

            var input = $(container.find("input"))
            input.attr('autocomplete', 'fakeautocomplete');

            if (typeof oncontentready != 'undefined') oncontentready(e)
            container.find('.dx-texteditor-input').off('keydown.next')
            container.find('.dx-texteditor-input').on('keydown.next', function (e) {
                const key = e.key || e.keyCode || e.which;
                if (key === 'Enter' || key === 13) {
                    e.preventDefault();
                    let inputs = $('.dx-texteditor-input:visible');
                    let index = inputs.index(this);
                    if (index > -1 && index + 1 < inputs.length) {
                        inputs.eq(index + 1).focus();
                    }
                }
            });
        }
        option.onInput = function (e) {
            e.event.target.value = e.event.target.value.toLowerCase();
            //e.component.option("value", e.event.target.value.toLowerCase());
        }
        option.maxLength = 450

        dx = $("<div/>").appendTo(container).dxCtrlTextBox(option).dxCtrlTextBox("instance");
        dx.option("onValueChanged", function (e) {
            if (e.value != null && e.value !== e.value.toLowerCase()) {
                dx.option("value", e.value.toLowerCase())
                return;
            }
            if (e.value == null || e.value.length==0 || (e.value && e.value.valideEmail())) {
                Me.mNoErreur();
                currentValue = e.value;
                if (typeof option.onValueChanged != 'undefined') { option.onValueChanged(e); }
            } else {
                Me.mDisplayErreur("L'adresse email saisie est erronée.")
            }
        });
        dx.option("onKeyDown", function (e) {
            Me.mNoErreur();
            //if (e.event.keyCode == 13) { e.component.blur() }
            if (typeof option.onKeyDown != 'undefined') { option.onKeyDown(e); }
        });
        $DivErreur = $("<div style='color:red;display:none;text-align:left;font-family:barlow condensed;font-size:80%;'>").appendTo(container);

        if (typeof option.txtTooltip != 'undefined' && option.txtTooltip.length > 0) {
            container.attr("title", option.txtTooltip.remplacerTout("<br/>", "%cr%"))
            //tt = $("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: container, position: "top", contentTemplate: function (contentElement) { $("<div style='font-size:110%;'>" + option.txtTooltip + "</div>").appendTo(contentElement); } }).dxCtrlTooltipHoverTarget("instance");
        }
    }

    this.component = function () { return dx; }

    this.focus = function () { dx.component().focus(); }

    this.mDisplayErreur = function (text) {
        this.hasErreur = true
        $DivErreur.text(text)
        $(dx.element().find(".dx-texteditor-input")).css("text-decoration", "line-through");
        $DivErreur.show();
    }
    this.mNoErreur = function () {
        this.hasErreur=false
        $(dx.element().find(".dx-texteditor-input")).css("text-decoration", "");
        $DivErreur.hide();
    }

    this.hasValue = function () {
        if (this.hasErreur) return false
        return (dx.option("value") != null && dx.option("value").length>0)
    }

    this.element = function () { return container; }


    mConstruit();
}